import { render, staticRenderFns } from "./FeedbackPlatform.vue?vue&type=template&id=89a3e556&scoped=true&"
import script from "./FeedbackPlatform.vue?vue&type=script&lang=ts&"
export * from "./FeedbackPlatform.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackPlatform.vue?vue&type=style&index=0&id=89a3e556&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a3e556",
  null
  
)

export default component.exports